import Keycloak from 'keycloak-js';

const sso = new Keycloak({
  url: import.meta.env.VITE_AUTH_URL || 'https://auth.roommatik.com',
  realm: import.meta.env.VITE_AUTH_REALM || 'roommatik',
  clientId: import.meta.env.VITE_AUTH_CLIENT_ID || 'kyc',
});

export default sso;
